
import { Component, Vue } from 'vue-property-decorator';
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

@Component({
    components:{
        ExpandIcon
    }
})
export default class BookAppealDateRspToAppealPg extends Vue { 

    showAppealReadyInfo = true;
    showObtainInfo = false;
    showRespObtainInfo = false;
    showExpediteInfo = false;

    public showAppealReady(show: boolean){
        if (show) {
            this.showAppealReadyInfo = true;
            this.$emit('adjustHeights', 0, "7rem")
        } else {
            this.showAppealReadyInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showObtain(show: boolean){
        if (show) {
            this.showObtainInfo = true;
            this.$emit('adjustHeights', 1, "5rem")
        } else {
            this.showObtainInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showRespObtain(show: boolean){
        if (show) {
            this.showRespObtainInfo = true;
            this.$emit('adjustHeights', 2, "16.5rem")
        } else {
            this.showRespObtainInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showExpedite(show: boolean){
        if (show) {
            this.showExpediteInfo = true;
            this.$emit('adjustHeights', 3, "13rem")
        } else {
            this.showExpediteInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

}
